import { APP_STORE_URL } from "@/constants";

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6 fill-current" aria-hidden="true">
    <path d="M17.05 12.54c-.03-2.89 2.36-4.27 2.47-4.34-1.35-1.97-3.44-2.24-4.18-2.27-1.78-.18-3.47 1.05-4.37 1.05-.9 0-2.29-1.02-3.77-1-1.94.03-3.72 1.13-4.72 2.86-2.01 3.49-.51 8.66 1.45 11.49.96 1.39 2.1 2.94 3.6 2.88 1.45-.06 2-.93 3.74-.93s2.25.93 3.78.9c1.56-.03 2.55-1.41 3.5-2.8 1.1-1.61 1.55-3.17 1.58-3.25-.04-.02-3.03-1.16-3.08-4.59zM14.16 4.06c.8-.97 1.34-2.32 1.19-3.66-1.15.05-2.55.77-3.38 1.73-.74.86-1.39 2.23-1.22 3.55 1.29.1 2.6-.65 3.41-1.62z" />
  </svg>
);

export const AppStoreButton = ({ testId, variant = "solid", size = "lg", sublabel }) => {
  const base =
    "inline-flex items-center justify-center gap-3 rounded-xl font-semibold active:scale-[0.98] transition-[transform,background-color,border-color] duration-200";
  const styles =
    variant === "ghost"
      ? "bg-slate-900/90 text-white border border-white/20 hover:bg-slate-800 hover:border-white/40"
      : "bg-white text-slate-950 hover:bg-slate-100 shadow-lg shadow-sky-500/10";
  const sizing = size === "sm" ? "px-5 py-2.5 text-sm" : "px-7 py-4";

  return (
    <a
      data-testid={testId}
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${sizing}`}
    >
      <AppleIcon />
      <span className="flex flex-col items-start leading-tight">
        {sublabel && (
          <span className="text-[10px] font-medium uppercase tracking-wider opacity-70">
            {sublabel}
          </span>
        )}
        <span className={size === "sm" ? "text-sm" : "text-base"}>
          Download on the App Store
        </span>
      </span>
    </a>
  );
};
